import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    roles: null,
    payment: null
  },
  mutations: {
    commitUser(state, data) {
      state.user = data
    },

    commitRoles(state, data) {
      state.roles = data
    },
    setPaymentDetails(state, payment) {
      state.payment = payment
    }
  },
  actions: {
    async getUser({ commit }) {
      try {
        const dataRaw = window.localStorage.getItem("user")

        let dat1

        if (!dataRaw) {
          const { data } = await this._vm.$repos.authRepo.getUser()
          console.log("data store repo", data)
          window.localStorage.setItem("user", JSON.stringify(data));
          // window.localStorage.setItem("roles", data.data.roles);

          dat1 = data
        } else {
          const data = JSON.parse(dataRaw)
          dat1 = data
        }
        commit('commitUser', dat1)
        commit('commitRoles', dat1.roles)

      } catch (error) {
        console.log(error)
      }
    }
  },
  getters: {
    roleNames(state) {
      return state.roles.map(role => role.name)
    }
  },
  modules: {
  }
})
